import { clsx } from "clsx";

import { Icon } from "../icon/Icon";

import "./Tag.css";

import type { CSSProperties, ReactNode } from "react";
import type { IconVariantProp } from "../icon/Icon";

export interface TagProps {
  blend?: boolean;
  children?: ReactNode;
  color?: string;
  icon?: "white" | "neutral" | string;
  iconVariant?: IconVariantProp;
  text?: string;
}

export function getCustomProperties(color?: string) {
  if (!color) return [];
  switch (color) {
    case "white":
      return ["var(--color-white)", "var(--color-neutral-60)"];
    case "neutral":
      return ["var(--color-neutral-80)", "var(--color-white)"];
    default:
      return [color, `var(--color-white)`];
  }
}

export function Tag({
  blend,
  children,
  color,
  icon,
  iconVariant,
  text,
}: TagProps) {
  const className = clsx("Tag", { "Tag--blend": blend });
  const [backgroundColor, textColor] = getCustomProperties(color);
  const customProperties = {
    "--tag-background": backgroundColor,
    "--tag-color": textColor,
  } as CSSProperties;

  return (
    <div className={className} style={customProperties}>
      {icon && (
        <span className={"Tag__icon"}>
          <Icon icon={icon} variant={iconVariant} size={"sm"} />
        </span>
      )}
      <span className="Tag__text">
        {text}
        {children}
      </span>
    </div>
  );
}
